import {
  CircularProgress,
  Grid,
  ListItemText,
  Switch,
} from '@material-ui/core';
import { useUID } from '@superdispatch/ui';
import { NotificationsSettingsFormResult } from './data/NotificationsSettingsFormState';
import { AllNotificationDisabledWarning } from './NotificationSettingWarnings';

export function AllNotificationsActivity({
  isLoading,
  hasDisabled,
  allNotificationForm: { isSubmitting, handleSubmit },
}: NotificationsSettingsFormResult) {
  const uid = useUID();

  return (
    <Grid container={true} spacing={2}>
      <Grid item={true} xs={12}>
        <Grid
          container={true}
          aria-labelledby={uid}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item={true} xs={9}>
            <ListItemText
              primary="All Notifications"
              primaryTypographyProps={{ id: uid, variant: 'h4' }}
              secondary="Load Alerts, Suggested Loads and Declined Loads"
            />
          </Grid>

          <Grid item={true} xs="auto">
            {!isSubmitting ? (
              <Switch
                color="primary"
                checked={!hasDisabled}
                disabled={isLoading}
                onChange={() => {
                  handleSubmit();
                }}
                inputProps={{ 'aria-label': 'Toggle all' }}
              />
            ) : (
              <CircularProgress color="primary" size={25} />
            )}
          </Grid>
        </Grid>
      </Grid>

      {hasDisabled && (
        <Grid item={true} xs={12}>
          <AllNotificationDisabledWarning />
        </Grid>
      )}
    </Grid>
  );
}
